import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BILLING_PATH } from '../utils/upgradeError';

interface UpgradeErrorMessageProps {
    message: string;
    onNavigate?: () => void;
}

const UpgradeErrorMessage: React.FC<UpgradeErrorMessageProps> = ({ message, onNavigate }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onNavigate) onNavigate();
        navigate(BILLING_PATH);
    };

    return (
        <span>
            {message}{' '}
            <Button
                variant="link"
                className="p-0 align-baseline font-xs"
                onClick={handleClick}
            >
                Go to Billing
            </Button>
        </span>
    );
};

export default UpgradeErrorMessage;
